import {
  FETCH_CONTACTUS_DATA,
  FETCH_CONTACTUS_SUCCESS,
  FETCH_CONTACTUS_FAILURE,
  FETCH_CONTACTUS_EDIT_DATA,
  FETCH_CONTACTUS_EDIT_SUCCESS,
  FETCH_CONTACTUS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchContactUsData = () => ({
  type: FETCH_CONTACTUS_DATA,
});

export const fetchContactUsSuccess = (data) => ({
  type: FETCH_CONTACTUS_SUCCESS,
  payload: data,
});

export const fetchContactUsFailure = (error) => ({
  type: FETCH_CONTACTUS_FAILURE,
  payload: error,
});

export const fetchContactUsEditData = (id) => ({
  type: FETCH_CONTACTUS_EDIT_DATA,
  payload: id,
});

export const fetchContactUsEditSuccess = (data) => ({
  type: FETCH_CONTACTUS_EDIT_SUCCESS,
  payload: data,
});

export const fetchContactUsEditFailure = (error) => ({
  type: FETCH_CONTACTUS_EDIT_FAILURE,
  payload: error,
});
